import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const NZIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="NZ" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <G clipPath="url(#b)">
        <Path fill="#2E42A5" d="M0 0h8.8v7.2H0z" />
        <Path
          fill="#F7FCFF"
          d="m-1.802 6.5 1.98.868L8.245.944 9.29-.346l-2.118-.29-3.29 2.768-2.649 1.865L-1.802 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m-1.531 7.108 1.009.505 9.436-8.08H7.498l-9.029 7.575Z"
        />
        <Path
          fill="#F7FCFF"
          d="M9.202 6.5 7.444 7.616-.845.944-1.89-.346l2.118-.29 3.29 2.768 2.649 1.865L9.202 6.5Z"
        />
        <Path
          fill="#F50100"
          d="m9.135 6.937-1.01.504-4.018-3.46-1.19-.386L-1.99-.342h1.417L4.33 3.502l1.303.463 3.502 2.972Z"
        />
        <Path
          fill="#F50100"
          fillRule="evenodd"
          d="M4 0h-.8v3.2h-4V4h4v3.2H4V4h4v-.8H4V0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M2.45 0h2.3v2.45L8 2.4v2.3l-3.25.05V7.2h-2.3V4.75L-.8 4.7V2.4l3.25.05V0Zm.75 3.2h-4V4h4v3.2H4V4h4v-.8H4V0h-.8v3.2Z"
          clipRule="evenodd"
        />
      </G>
      <Path
        fill="#F50100"
        fillRule="evenodd"
        stroke="#F7FCFF"
        strokeWidth={0.4}
        d="m12.427 10.25-.882.463.168-.981L11 9.036l.986-.143.44-.893.441.893.986.143-.713.696.168.982-.881-.464ZM10.6 6.935l-.68.357.13-.757L9.5 6l.76-.11.34-.689.34.689.76.11-.55.536.13.757-.68-.357ZM14.099 6.933l-.68.357.13-.756L13 5.998l.76-.11.339-.688.34.688.759.11-.55.536.13.756-.68-.357ZM12.6 4.135l-.68.357.13-.757-.55-.536.76-.11.34-.69.34.69.76.11-.55.536.13.757-.68-.357Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
      <ClipPath id="b">
        <Path fill="#fff" d="M0 0h8.8v7.2H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
